import { useTreeCourses } from '@/data/context/TreeCoursesContext';
import { getDomainFromType } from '@/utils/courses';
import { CoursesModelsType, CoursesNode } from '@/utils/trees/TreeCourses';
import { useEffect, useMemo, useState } from 'react';

const ORQUESTER_SUBSCRIPTION_ID = 'course-file-tree-orquester';

export default function useTreeOrquester() {
  const [path, setPath] = useState<CoursesNode[]>([]);

  const { pathObserver } = useTreeCourses();

  useEffect(() => {
    pathObserver?.subscribe({
      id: ORQUESTER_SUBSCRIPTION_ID,
      action: path => {
        setPath(path ?? []);
      },
    });

    return () => {
      pathObserver?.unsubscribe(ORQUESTER_SUBSCRIPTION_ID);
    };
  }, [pathObserver]);

  const domain = useMemo(() => {
    if (path.length === 0) return null;

    const lastNode = path.at(-1);

    return getDomainFromType(lastNode?.type as CoursesModelsType) ?? null;
  }, [path]);

  return {
    domain,
  };
}
